(($) => {
	const $accordion = $('.accordion_2');

	// const toggleIcon = (e) => $(e.target).prev('.panel-heading').find(".indicator").toggleClass('ti-minus ti-plus');
	const toggleChevron = (e) => $(e.target).prev('.card-header').find("i.indicator").toggleClass('ti-minus ti-plus');

	$accordion.on('hidden.bs.collapse shown.bs.collapse', toggleChevron);
})(jQuery);